import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TrainSeatSolid = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9.62 1.042a1.028 1.028 0 0 0-.425.229.943.943 0 0 0-.134.209L9 1.613l-.008 1.674c-.004.953.003 1.673.016 1.673.018 0 1.228-1.088 1.744-1.567l.072-.067.581.53c.32.291.637.582.705.645l.124.114.472-.431.472-.43.084.08c.365.345 1.709 1.553 1.728 1.553.016 0 .022-.731.018-1.887L15 1.613l-.061-.133a.714.714 0 0 0-.389-.378l-.163-.075-2.334-.005c-1.304-.002-2.377.007-2.433.02m-5.98.292c-.289.021-.485.078-.829.238-.421.196-.839.528-1.042.828-.103.153-.21.422-.247.625-.04.22-.04 8.98 0 9.203.103.573.597 1.075 1.238 1.261.297.086.537.111 1.052.111h.481v.822l-.753.011c-.627.01-.778.02-.9.059a1.579 1.579 0 0 0-.977.835l-.093.193h-.346c-.293 0-.362.008-.45.053a.46.46 0 0 0-.262.398.468.468 0 0 0 .28.492c.078.04.654.044 6.698.044 4.608 0 6.636-.009 6.688-.029.166-.062.327-.291.328-.466.001-.123-.118-.336-.23-.412l-.099-.067-1.47-.007-1.471-.007-.061-.148c-.138-.333-.424-.609-.813-.785-.298-.135-.479-.159-1.204-.159h-.651V13.6h1.061c.624 0 1.127-.012 1.22-.028.851-.151 1.485-.7 1.658-1.438.069-.292.068-1.448-.001-1.72a1.57 1.57 0 0 0-.469-.814 2.1 2.1 0 0 0-1.238-.611C10.6 8.97 9.544 8.96 7.61 8.96c-3.105 0-3.039.003-3.087-.121a34.698 34.698 0 0 1-.016-1.455V5.973h.326c.456-.002.976-.043 1.188-.095.495-.122.779-.415.858-.887.02-.12.028-.637.022-1.591l-.008-1.413-.072-.137c-.159-.302-.516-.474-1.046-.503-.45-.024-1.867-.033-2.135-.013m2.049 1.003.204.017V4.877l-.1.031c-.056.018-.362.037-.693.045l-.593.013V2.32h.489c.269 0 .581.008.693.017m4.283 3.118c-.461.42-.868.791-.903.826l-.064.062.048.127c.1.261.357.453.692.514.106.02.85.029 2.253.029 2.26-.001 2.307-.003 2.579-.142a.913.913 0 0 0 .205-.145l.075-.079-.142-.133a72.749 72.749 0 0 0-1.541-1.393c-.007.001-.218.187-.467.413a6.936 6.936 0 0 1-.474.413c-.012 0-.328-.279-.701-.62a26.375 26.375 0 0 0-.701-.628c-.012-.004-.398.336-.859.756m-2.479 8.558v.414H5.307V13.6h2.186v.413m2.4 1.458c.088.042-.125.045-3.506.046-2.321.001-3.585-.008-3.556-.024a.795.795 0 0 1 .186-.05c.081-.014 1.592-.022 3.463-.02 3.04.003 3.328.007 3.413.048" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { TrainSeatSolid };